<template>
  <div class="form-group delivery-confirmation">
    <div class="label required fs-xl">Denmark registered letter delivery</div>
    <div class="row">
      <div class="col-12 col-md-4">
        <input
          id="delivery_confirmation_none"
          v-model="confirmation"
          :value="NONE"
          name="delivery_confirmation"
          type="radio"
        />
        <label for="delivery_confirmation_none" class="radio-group">
          <span class="radio-title">Home delivery</span>
          <span class="radio-description">Delivery to the mailbox or doorstep with proof of delivery.</span>
        </label>
      </div>
      <div class="col-12 col-md-4">
        <input
          id="delivery_confirmation_signature"
          v-model="confirmation"
          :value="SIGNATURE"
          name="delivery_confirmation"
          type="radio"
        />
        <label for="delivery_confirmation_signature" class="radio-group">
          <span class="radio-title">Home delivery with signature</span>
          <span class="radio-description">The recipient must show ID and sign for the delivery.</span>
        </label>
      </div>
      <div class="col-12 col-md-4">
        <input
          id="delivery_confirmation_pickup_point"
          v-model="confirmation"
          :value="PICKUP_POINT"
          name="delivery_confirmation"
          type="radio"
        />
        <label for="delivery_confirmation_pickup_point" class="radio-group">
          <span class="radio-title">Pakkeshop</span>
          <span class="radio-description">Delivery to a pickup point where the recipient identifies themselves.</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DeliveryConfirmation } from '@/types/Models/Assignment'
import { computed } from 'vue'
import { NONE, PICKUP_POINT, SIGNATURE } from '@/const/DeliveryConfirmations'
import { useAssignmentFormStore } from '@/store/assignmentForm'

const assignmentFormStore = useAssignmentFormStore()
const confirmation = computed({
  get: () => assignmentFormStore.assignment.delivery_confirmation,
  set: (delivery_confirmation: DeliveryConfirmation) => assignmentFormStore.setFields({ delivery_confirmation }),
})
</script>
